// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, PropsWithChildren, ReactElement, useState, useEffect } from "react";
import ToggleSwitch from "../../components/ToggleSwitch";
import ListAccounts from "../../components/list-views/ListAccounts";
import { ToggleSwitchState } from "../../data/utils/types";
import { useLocation } from "react-router-dom";
import ListMyAccounts from "../../components/list-views/ListMyAccounts";


interface AccountsPropsInterface {
}

export const Accounts: FunctionComponent<PropsWithChildren<AccountsPropsInterface>> = (
): ReactElement => {
   const [toggleSwitchState, setToggleSwitchState] = useState<ToggleSwitchState>("active-accounts");
   const [isMyAccounts, setMyAccounts] = useState<boolean>(true);
   const location = useLocation();

   const handleToggleSwitchClick = (state: ToggleSwitchState) => {
      setToggleSwitchState(state);
   };

   useEffect(() => {
      const path = location.pathname.slice(1);
      if (path.split("/")[1] == "my-accounts") {
         setMyAccounts(true);
      } else if (path.split("/")[1] == "all-accounts") {
         setMyAccounts(false);
      }
   }, [location]);

   if (isMyAccounts) {
      if (toggleSwitchState === "active-accounts") {
         return (
            <>
               <ToggleSwitch page={"active-accounts"} onSwitchClick={handleToggleSwitchClick} />
               <ListMyAccounts active={true} />
            </>
         );
      } else {
         return (
            <>
               <ToggleSwitch page={"all-accounts"} onSwitchClick={handleToggleSwitchClick} />
               <ListMyAccounts active={false} />
            </>
         );
      }
   } else {
      if (toggleSwitchState === "active-accounts") {
         return (
            <>
               <ToggleSwitch page={"active-accounts"} onSwitchClick={handleToggleSwitchClick} />
               < ListAccounts active={true} />
            </>
         );
      } else {
         return (
            <>
               <ToggleSwitch page={"all-accounts"} onSwitchClick={handleToggleSwitchClick} />
               <ListAccounts active={false} />
            </>
         );
      }
   }

}
